import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, TextAreaBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals';

class TextAreaBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: "It's a sunny day"
			}
		};
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="TextAreaBox">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={4}>
							<Label htmlFor="default">Default</Label>
							<TextAreaBox name="default" />
						</Col>
						<Col md={4}>
							<Label htmlFor="placeholder">Placeholder</Label>
							<TextAreaBox name="placeholder" placeholder="Enter some text..." />
						</Col>
						<Col md={4}>
							<Label htmlFor="disabled">Disabled</Label>
							<TextAreaBox name="disabled" disabled={true} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label htmlFor="preset">Preset</Label>
							<TextAreaBox name="preset" />
						</Col>
						<Col md={4}>
							<Label htmlFor="validationError" required>Required</Label>
							<TextAreaBox name="required" required />
						</Col>
						<Col md={4}>
							<Label htmlFor="maxLength">Max Length</Label>
							<TextAreaBox name="maxLength" maxLength={255} rows={3} />
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default TextAreaBoxDemo;


// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/TextAreaBoxDemo.js